import { RootState } from '../store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Api } from "@/api/api";
import { Walk } from "@/domain/walk";

export interface WalkState {
  walkToFinish: Walk | undefined;
  allWalks: Walk[];
  activeWalks: Walk[];
  activeWalk: Walk | undefined,
  newWalk: Walk | undefined;
  marginInMeters: number;
  walkDetails: Walk | undefined;
}

export const state: WalkState = {
  walkToFinish: undefined,
  allWalks: [],
  activeWalks: [],
  activeWalk: undefined,
  newWalk: undefined,
  walkDetails: undefined,
  marginInMeters: 250
};

export const getters: GetterTree<WalkState, RootState> = {
  getAllWalks: state => state.allWalks,
  getActiveWalks: state => state.activeWalks,
  getNewWalk: state => state.newWalk,
  getWalkToFinish: state => state.walkToFinish,
  getMarginInMeters: state => state.marginInMeters,
  getActiveWalk: state => state.activeWalk,
  getWalkDetails: state => state.walkDetails
};

export const mutations: MutationTree<WalkState> = {
  SET_ALL_WALKS: (state, allWalks) => state.allWalks = allWalks,
  SET_ACTIVE_WALKS: (state, activeWalks) => state.activeWalks = activeWalks,
  SET_WALK_TO_FINISH: (state, walkToFinish) => state.walkToFinish = walkToFinish,
  SET_ACTIVE_WALK: (state, activeWalk) => state.activeWalk = activeWalk,
  SET_NEW_WALK: (state, newWalk) => state.newWalk = newWalk,
  SET_WALK_DETAILS: (state, walkDetails) => state.walkDetails = walkDetails,
};

export const actions: ActionTree<WalkState, RootState> = {
  FETCH_ALL_WALKS({ commit }) {
    return Api.Walk.fetchAllWalks()
        .then(response => commit('SET_ALL_WALKS', response.walks))
  },
  FETCH_ACTIVE_WALKS({ commit }) {
    return Api.Walk.fetchActiveWalks()
        .then(response => commit('SET_ACTIVE_WALKS', response.walks))
  },
  SET_NEW_WALK ({ commit }, newWalk: Walk) {
    commit('SET_NEW_WALK', newWalk)
  },
  async SAVE_NEW_WALK ({ commit }, walk: Walk) {
    return await Api.Walk.saveNewWalk(walk);
  },
  SET_WALK_TO_FINISH ({ commit }, walkToFinish: Walk) {
    commit('SET_WALK_TO_FINISH', walkToFinish)
  },
  async FINISH_WALK ({ commit }, walk: Walk) {
    return await Api.Walk.finishWalk(walk);
  },
  async UPDATE_WALK ({ commit }, walk: Walk) {
    return await Api.Walk.updateWalk(walk);
  },
  async FETCH_WALK_DETAILS ({ commit }, walkId: number) {
    return await Api.Walk.getWalkDetails(walkId).then(
        walkDetails => commit('SET_WALK_DETAILS', walkDetails)
    )
  }
};

export const WalkStore: Module<WalkState, RootState> = {
  state,
  getters,
  mutations,
  actions
};
